import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../utils/api';

const STATUS_COLORS = { aprovado:'#0FA36B', pendente:'#F59E0B', nao_verificado:'#9095A8' };
const STATUS_LABELS = { aprovado:'Aprovado', pendente:'Pendente', nao_verificado:'Não verificado' };

const Field = ({ label, value }) => (
  <div style={{marginBottom:14}}>
    <div style={{fontSize:11,fontWeight:600,color:'#9095A8',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:3}}>{label}</div>
    <div style={{fontSize:13,color:'#0B0E1A'}}>{value || '—'}</div>
  </div>
);

const Bool = ({ label, value }) => (
  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
    <div style={{width:18,height:18,borderRadius:4,background:value?'#0FA36B':'#E2E4ED',display:'flex',alignItems:'center',justifyContent:'center'}}>
      {value && <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
    </div>
    <span style={{fontSize:13,color:'#3D4461'}}>{label}</span>
  </div>
);

export default function FornecedorDetalhe() {
  const { id } = useParams();
  const { token } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState(null);
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({});
  const [salvando, setSalvando] = useState(false);
  const [arquivos, setArquivos] = useState([]);
  const [novoArquivo, setNovoArquivo] = useState({ nome:'', tipo:'documento', file:null });
  const [uploadando, setUploadando] = useState(false);

  const carregar = () => {
    api.get(`/fornecedores/${id}`, token).then(data => {
      setF(data);
      setForm(data);
      setArquivos(data.arquivos || []);
    }).catch(console.error);
  };

  useEffect(() => { carregar(); }, [id, token]);

  const salvar = async () => {
    setSalvando(true);
    try {
      const updated = await api.put(`/fornecedores/${id}`, form, token);
      setF({...updated, arquivos});
      setEditando(false);
    } catch(e) { alert('Erro ao salvar'); }
    setSalvando(false);
  };

  const excluir = async () => {
    if (!window.confirm('Excluir este fornecedor?')) return;
    try {
      await api.del(`/fornecedores/${id}`, token);
      navigate('/mentor/fornecedores/lista');
    } catch (e) {
      alert('Erro ao excluir: ' + (e.message || 'tente novamente'));
    }
  };

  const uploadArquivo = async () => {
    if (!novoArquivo.file) return alert('Selecione um arquivo');
    if (!novoArquivo.nome) return alert('Digite o nome do documento');
    setUploadando(true);
    try {
      const formData = new FormData();
      formData.append('arquivo', novoArquivo.file);
      formData.append('nome', novoArquivo.nome);
      formData.append('tipo', novoArquivo.tipo);
      const res = await fetch(`/api/fornecedores/${id}/arquivos`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const data = await res.json();
      setArquivos(a => [...a, data]);
      setNovoArquivo({ nome:'', tipo:'documento', file:null });
    } catch(e) { alert('Erro ao fazer upload'); }
    setUploadando(false);
  };

  const excluirArquivo = async (arquivoId) => {
    if (!window.confirm('Excluir este arquivo?')) return;
    await fetch(`/api/fornecedores/${id}/arquivos/${arquivoId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    });
    setArquivos(a => a.filter(x => x.id !== arquivoId));
  };

  const inp = (field, value) => setForm(f => ({ ...f, [field]: value }));

  if (!f) return <div style={{padding:32,color:'#6B7289',fontSize:13}}>Carregando...</div>;

  return (
    <div style={{padding:32,maxWidth:900,margin:'0 auto'}}>
      <button onClick={() => navigate('/mentor/fornecedores/lista')}
        style={{background:'none',border:'none',color:'#6B7289',fontSize:13,cursor:'pointer',padding:'0 0 16px',display:'flex',alignItems:'center',gap:6}}>
        ← Voltar à lista
      </button>

      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:28}}>
        <div>
          <h1 style={{fontSize:22,fontWeight:700,color:'#0B0E1A',margin:0}}>{f.empresa}</h1>
          <div style={{fontSize:13,color:'#6B7289',marginTop:4}}>
            {[f.cidade, f.estado, f.pais].filter(Boolean).join(' · ')}
          </div>
          <span style={{display:'inline-block',marginTop:8,background:STATUS_COLORS[f.status]+'22',color:STATUS_COLORS[f.status],fontSize:11,fontWeight:600,padding:'3px 10px',borderRadius:99}}>
            {STATUS_LABELS[f.status] || f.status}
          </span>
        </div>
        <div style={{display:'flex',gap:10}}>
          {!editando && <button onClick={() => setEditando(true)} style={{background:'#1A2ECC',color:'#fff',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'}}>Editar</button>}
          {editando && <>
            <button onClick={() => setEditando(false)} style={{background:'#F4F5F9',color:'#3D4461',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'}}>Cancelar</button>
            <button onClick={salvar} disabled={salvando} style={{background:'#0FA36B',color:'#fff',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'}}>
              {salvando ? 'Salvando...' : 'Salvar'}
            </button>
          </>}
          <button onClick={excluir} style={{background:'#FEE2E2',color:'#D63B3B',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'}}>Excluir</button>
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:20}}>
        {/* Informações comerciais */}
        <div style={{background:'#fff',borderRadius:12,padding:24,boxShadow:'0 1px 4px rgba(0,0,0,.06)'}}>
          <div style={{fontSize:13,fontWeight:700,color:'#0B0E1A',marginBottom:18}}>Informações comerciais</div>
          {editando ? (
            <>
              {[['Tipo','tipo'],['Segmento','segmento'],['Principais produtos','principais_produtos'],['Status','status']].map(([l,field]) => (
                <div key={field} style={{marginBottom:12}}>
                  <label style={{fontSize:11,fontWeight:600,color:'#9095A8',display:'block',marginBottom:4}}>{l}</label>
                  {field === 'tipo'
                    ? <select value={form[field]||''} onChange={e=>inp(field,e.target.value)} style={{width:'100%',padding:'8px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none'}}>
                        {['Fabricante','Distribuidor','Trading','Atacadista'].map(t=><option key={t} value={t}>{t}</option>)}
                      </select>
                    : field === 'status'
                    ? <select value={form[field]||''} onChange={e=>inp(field,e.target.value)} style={{width:'100%',padding:'8px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none'}}>
                        <option value="nao_verificado">Não verificado</option>
                        <option value="pendente">Pendente</option>
                        <option value="aprovado">Aprovado</option>
                      </select>
                    : <input value={form[field]||''} onChange={e=>inp(field,e.target.value)} style={{width:'100%',padding:'8px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box'}} />
                  }
                </div>
              ))}
              <div style={{display:'flex',flexDirection:'column',gap:8,marginTop:8}}>
                {[['atacado_real','Atacado real'],['aceita_oem','Aceita OEM'],['aceita_private_label','Aceita Private Label']].map(([field,l])=>(
                  <label key={field} style={{display:'flex',alignItems:'center',gap:6,fontSize:13,cursor:'pointer'}}>
                    <input type="checkbox" checked={!!form[field]} onChange={e=>inp(field,e.target.checked)} />{l}
                  </label>
                ))}
              </div>
            </>
          ) : (
            <>
              <Field label="Tipo" value={f.tipo} />
              <Field label="Segmento" value={f.segmento} />
              <Field label="Principais produtos" value={f.principais_produtos} />
              <Bool label="Atacado real" value={f.atacado_real} />
              <Bool label="Aceita OEM" value={f.aceita_oem} />
              <Bool label="Aceita Private Label" value={f.aceita_private_label} />
            </>
          )}
        </div>

        {/* Contato */}
        <div style={{background:'#fff',borderRadius:12,padding:24,boxShadow:'0 1px 4px rgba(0,0,0,.06)'}}>
          <div style={{fontSize:13,fontWeight:700,color:'#0B0E1A',marginBottom:18}}>Contato</div>
          {editando ? (
            [['E-mail','email'],['Telefone','telefone'],['Site','site'],['WeChat','wechat'],['Cidade','cidade'],['Estado / Província','estado'],['País','pais'],['Fonte','fonte']].map(([l,field])=>(
              <div key={field} style={{marginBottom:12}}>
                <label style={{fontSize:11,fontWeight:600,color:'#9095A8',display:'block',marginBottom:4}}>{l}</label>
                <input value={form[field]||''} onChange={e=>inp(field,e.target.value)} style={{width:'100%',padding:'8px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box'}} />
              </div>
            ))
          ) : (
            <>
              <div style={{display:'flex',alignItems:'center',gap:6}}>
                <Field label="E-mail" value={f.email} />
                {f.email && <button onClick={()=>navigator.clipboard.writeText(f.email)} style={{background:'#EEF1FF',border:'none',borderRadius:4,padding:'3px 8px',fontSize:11,cursor:'pointer',color:'#1A2ECC',marginTop:16}}>📋</button>}
              </div>
              <div style={{display:'flex',alignItems:'center',gap:6}}>
                <Field label="Telefone/WhatsApp" value={f.telefone} />
                {f.telefone && <button onClick={()=>navigator.clipboard.writeText(f.telefone)} style={{background:'#EEF1FF',border:'none',borderRadius:4,padding:'3px 8px',fontSize:11,cursor:'pointer',color:'#1A2ECC',marginTop:16}}>📋</button>}
              </div>
              <div style={{display:'flex',alignItems:'center',gap:6}}>
                <Field label="Site" value={f.site} />
                {f.site && <button onClick={()=>navigator.clipboard.writeText(f.site)} style={{background:'#EEF1FF',border:'none',borderRadius:4,padding:'3px 8px',fontSize:11,cursor:'pointer',color:'#1A2ECC',marginTop:16}}>📋</button>}
              </div>
              <div style={{display:'flex',alignItems:'center',gap:6}}>
                <Field label="WeChat" value={f.wechat} />
                {f.wechat && <button onClick={()=>navigator.clipboard.writeText(f.wechat)} style={{background:'#EEF1FF',border:'none',borderRadius:4,padding:'3px 8px',fontSize:11,cursor:'pointer',color:'#1A2ECC',marginTop:16}}>📋</button>}
              </div>
              <Field label="Site" value={f.site} />
              <Field label="WeChat" value={f.wechat} />
              <Field label="Fonte" value={f.fonte} />
              <Field label="Atualizado em" value={f.atualizado_em ? new Date(f.atualizado_em).toLocaleString('pt-BR') : null} />
            </>
          )}
        </div>

        {/* Observações */}
        <div style={{background:'#fff',borderRadius:12,padding:24,boxShadow:'0 1px 4px rgba(0,0,0,.06)',gridColumn:'1/-1'}}>
          <div style={{fontSize:13,fontWeight:700,color:'#0B0E1A',marginBottom:14}}>Observações</div>
          {editando
            ? <textarea value={form.observacoes||''} onChange={e=>inp('observacoes',e.target.value)} rows={4}
                style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',resize:'vertical',boxSizing:'border-box'}} />
            : <div style={{fontSize:13,color:'#3D4461',whiteSpace:'pre-wrap'}}>{f.observacoes || 'Sem observações.'}</div>
          }
        </div>

        {/* Observações internas */}
        <div style={{background:'#FFF9EC',borderRadius:12,padding:24,boxShadow:'0 1px 4px rgba(0,0,0,.06)',gridColumn:'1/-1',border:'1px solid #FDE68A'}}>
          <div style={{fontSize:13,fontWeight:700,color:'#92400E',marginBottom:14}}>Observações internas (admin)</div>
          {editando
            ? <textarea value={form.observacoes_internas||''} onChange={e=>inp('observacoes_internas',e.target.value)} rows={3}
                style={{width:'100%',padding:'9px 12px',border:'1px solid #FDE68A',borderRadius:8,fontSize:13,outline:'none',resize:'vertical',boxSizing:'border-box',background:'#FFFDF5'}} />
            : <div style={{fontSize:13,color:'#78350F',whiteSpace:'pre-wrap'}}>{f.observacoes_internas || 'Sem anotações.'}</div>
          }
        </div>

        {/* Anexos */}
        <div style={{background:'#fff',borderRadius:12,padding:24,boxShadow:'0 1px 4px rgba(0,0,0,.06)',gridColumn:'1/-1'}}>
          <div style={{fontSize:13,fontWeight:700,color:'#0B0E1A',marginBottom:18}}>Documentos e Anexos</div>

          {/* Lista de arquivos */}
          {arquivos.length === 0
            ? <div style={{fontSize:13,color:'#9095A8',marginBottom:20}}>Nenhum arquivo enviado ainda.</div>
            : <div style={{marginBottom:20}}>
                {arquivos.map(a => (
                  <div key={a.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 14px',background:'#F4F5F9',borderRadius:8,marginBottom:8}}>
                    <div style={{display:'flex',alignItems:'center',gap:10}}>
                      <div style={{width:32,height:32,background:'#EEF1FF',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A2ECC" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:600,color:'#0B0E1A'}}>{a.nome}</div>
                        <div style={{fontSize:11,color:'#9095A8'}}>{a.tipo} · {new Date(a.criado_em).toLocaleDateString('pt-BR')}</div>
                      </div>
                    </div>
                    <div style={{display:'flex',gap:8}}>
                      <a href={a.url} target="_blank" rel="noreferrer"
                        style={{background:'#EEF1FF',color:'#1A2ECC',border:'none',borderRadius:6,padding:'6px 12px',fontSize:12,fontWeight:600,cursor:'pointer',textDecoration:'none'}}>
                        Abrir
                      </a>
                      <button onClick={() => excluirArquivo(a.id)}
                        style={{background:'#FEE2E2',color:'#D63B3B',border:'none',borderRadius:6,padding:'6px 12px',fontSize:12,fontWeight:600,cursor:'pointer'}}>
                        Excluir
                      </button>
                    </div>
                  </div>
                ))}
              </div>
          }

          {/* Novo arquivo */}
          <div style={{border:'1px dashed #C8CADC',borderRadius:10,padding:16}}>
            <div style={{fontSize:12,fontWeight:600,color:'#6B7289',marginBottom:12}}>Adicionar documento</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr auto',gap:10,alignItems:'end'}}>
              <div>
                <label style={{fontSize:11,fontWeight:600,color:'#9095A8',display:'block',marginBottom:4}}>Nome do documento</label>
                <input value={novoArquivo.nome} onChange={e=>setNovoArquivo(n=>({...n,nome:e.target.value}))}
                  placeholder="Ex: Catálogo 2025, Cartão de visita..."
                  style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box'}} />
              </div>
              <div>
                <label style={{fontSize:11,fontWeight:600,color:'#9095A8',display:'block',marginBottom:4}}>Tipo</label>
                <select value={novoArquivo.tipo} onChange={e=>setNovoArquivo(n=>({...n,tipo:e.target.value}))}
                  style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none'}}>
                  <option value="catalogo">Catálogo</option>
                  <option value="cartao">Cartão de visita</option>
                  <option value="certificado">Certificado</option>
                  <option value="documento">Documento</option>
                  <option value="foto">Foto</option>
                  <option value="outro">Outro</option>
                </select>
              </div>
              <div>
                <label style={{fontSize:11,fontWeight:600,color:'#9095A8',display:'block',marginBottom:4}}>Arquivo</label>
                <label style={{cursor:'pointer'}}>
                  <div style={{background:novoArquivo.file?'#EEF1FF':'#F4F5F9',border:'1px solid #E2E4ED',borderRadius:8,padding:'9px 14px',fontSize:13,color:novoArquivo.file?'#1A2ECC':'#6B7289',whiteSpace:'nowrap'}}>
                    {novoArquivo.file ? novoArquivo.file.name.slice(0,20)+'...' : 'Selecionar'}
                  </div>
                  <input type="file" style={{display:'none'}} onChange={e=>setNovoArquivo(n=>({...n,file:e.target.files[0]}))} />
                </label>
              </div>
            </div>
            <button onClick={uploadArquivo} disabled={uploadando}
              style={{marginTop:12,background:'#1A2ECC',color:'#fff',border:'none',borderRadius:8,padding:'9px 20px',fontSize:13,fontWeight:600,cursor:'pointer',opacity:uploadando?0.6:1}}>
              {uploadando ? 'Enviando...' : 'Enviar arquivo'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
